<template>
  <el-row class="container-card el-row">
    <div>
      <TrackDataCard />
      <!-- <TrackBarCard /> -->
      <TerritorialCard />
      <CategoryDataCard />
      <TopVideosCard />
      <TopTracksCard />
      <TopChannelsCard />
      <!-- <TracksCampaign /> -->
    </div>
  </el-row>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import TrackDataCard from '@/modules/artist/dashboard/components/TrackDataCard'
// import TrackBarCard from '@/modules/artist/dashboard/components/TrackBarCard'
import TopTracksCard from '@/modules/artist/dashboard/components/TopTracksCard'
// import TracksCampaign from '@/modules/artist/dashboard/components/TracksCampaign'
import TopChannelsCard from '@/modules/artist/dashboard/components/TopChannelsCard'
import TopVideosCard from '@/modules/artist/dashboard/components/TopVideosCard'
import CategoryDataCard from '@/modules/artist/dashboard/components/CategoryDataCard'
import TerritorialCard from '@/modules/artist/dashboard/components/TerritorialCard'

export default {
  components: {
    TrackDataCard,
    TopTracksCard,
    TopChannelsCard,
    TopVideosCard,
    CategoryDataCard,
    TerritorialCard
  },

  computed: {
    ...mapGetters('auth', ['artist_role']),
    ...mapState('artistDashboard', ['artist_track'])
  },

  methods: {
    ...mapMutations('artistDashboard', [
      'setSelectedTrack',
      'setSelectedArtist'
    ])
  },

  created() {
    if (this.artist_role) {
      this.setSelectedArtist(null)
    }
  }
}
</script>
